import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';

import WDT_CLASSROOM_OVERALL_PROGRESS_QUERY from 'graph/reports/wdt-classroom-overall-progress-report-query';
import ActiveStudentsChart from './ActiveStudentsChart';
import CharactersAndTimeSpentChart from '../../common/CharactersAndTimeSpentChart';
import ActivitiesCompletedCharacterCard from './ActivitiesCompletedCharacterCard';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import { ModuleType } from '../../../../types';
import { getQueryVariables } from '../../../../utils/report-param-utils';
import { WdtClassroomModuleProgressData } from 'types/schema-generated-types';

const ClassroomOverallCards: React.FC = () => {
  const [{ dateRange, entityType, entityId }] = useReportQueryParams();

  const [fetchReport, { data, loading }] = useLazyQuery(WDT_CLASSROOM_OVERALL_PROGRESS_QUERY);

  const reportData: WdtClassroomModuleProgressData[] =
    data?.wdtClassroomOverallProgressReport?.progress ?? [];

  const totalStudentCount: number = data?.wdtClassroomOverallProgressReport?.totalStudentCount;

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType, dateRange }) });
  }, [fetchReport, entityId, entityType, dateRange]);

  return (
    <section>
      <Grid container wrap="wrap" spacing={2}>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.CAPITALS}
            reportData={reportData}
            totalStudentCount={totalStudentCount}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.LOWERCASE}
            reportData={reportData}
            totalStudentCount={totalStudentCount}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.NUMBERS}
            reportData={reportData}
            totalStudentCount={totalStudentCount}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActiveStudentsChart />
        </Grid>
        <Grid item xs={12}>
          <CharactersAndTimeSpentChart />
        </Grid>
      </Grid>
    </section>
  );
};

export default ClassroomOverallCards;
